import SessionMonitor from './SessionMonitor';

export default SessionMonitor;
